module.exports = __webpack_public_path__ + "static/andrei-constantin-258ba20deee1ab16d2f2f309a1b3395f.jpg";